<bzg-modal-header>
  <span class="bzg-modal__header__title bmc-delete-alert__title">{{ 'CHANGE_ADMINISTRATOR.CHANGE_ADMINISTRATOR' | translate}}</span>
</bzg-modal-header>
<bzg-modal-content class="bmc-delete-alert__body">
  <div class="change-administrator-dialog">
    <bzg-input [(ngModel)]="administratorUserName" [placeholder]="'CHANGE_ADMINISTRATOR.EMAIL_PLACEHOLDER' | translate" [pattern]="EMAIL_REGEXP">
      {{ 'CHANGE_ADMINISTRATOR.ENTER_NEW_ADMINISTRATOR_EMAIL' | translate}}
      <bzg-pattern-error>{{'GLOBAL.PLEASE_ENTER_A_VALID_EMAIL' | translate}}</bzg-pattern-error>
    </bzg-input>
    <label class="change-administrator-dialog__text">{{ 'CHANGE_ADMINISTRATOR.NOT_REVERSIBLE_ACTION' | translate}}</label>
    <label class="change-administrator-dialog__question">{{ 'CHANGE_ADMINISTRATOR.WANT_TO_CONTINUE' | translate}}</label>
  </div>
</bzg-modal-content>
<bzg-modal-footer class="bmc-delete-alert__footer">
  <bzg-button-secondary class="bz-space--inline-m" (click)="close()">{{ 'GLOBAL.CANCEL' | translate}}</bzg-button-secondary>
  <bzg-button-primary color="error" (click)="change()" [disabled]="!administratorUserName || (administratorUserName && !isValidEmail())">{{ 'CHANGE_ADMINISTRATOR.CHANGE_ADMINISTRATOR' | translate}}</bzg-button-primary>
</bzg-modal-footer>
